import Utils from '@/utils/util';
import { DropDown } from '@/components/dropdown/DropDown';
import { ReactComponent as WarningIcon } from '@/assets/img/warning.svg';
import { ReactComponent as DeleteIcon } from '@/assets/img/delete-icon-v2.svg';
import { ReactComponent as EditIcon } from '@/assets/img/edit-icon-new-v2.svg';

import './Recurring.scss';
import moment from 'moment';
import { RecurringAppointment, Slot } from '../api/getRecurringSlots';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import { useAuth } from '@/lib/auth';
import DatePickerWithPortal from '@/components/DatePicker/DatepickerWithPortal';
import { Day, DayValue } from 'react-modern-calendar-datepicker';
import { t } from 'i18next';
import { Loader } from '@/components/Loader/Loader';
type RecurringCardProps = {
  itemIndex: number;
  recurringData: RecurringAppointment;
  onChange: (data: RecurringAppointment, index: number) => void;
  onDeleteClicked: (data: RecurringAppointment, index: number) => void;
  onEditDate: (date: string) => void;
  disableDelete?: boolean;
  isLoading: boolean;
};

export const RecurringCard = ({
  recurringData,
  itemIndex,
  onChange,
  onDeleteClicked,
  disableDelete = false,
  onEditDate,
  isLoading,
}: RecurringCardProps) => {
  const { user } = useAuth();
  const [day] = useState<Day>({
    day: moment().date(),
    month: moment().month() + 1,
    year: moment().year(),
  } as Day);

  const [busyStartTime, setBusyStartTime] = useState('');
  useEffect(() => {
    if (recurringData.status === 'busy') {
      setBusyStartTime(recurringData.startTime);
    }
  }, []);

  const renderTooltip = (props: any) => (
    <Tooltip id="button-tooltip" {...props}>
      This slot is not available for booking
    </Tooltip>
  );
  const onSlotSelect = (data: Slot) => {
    if (data.status === 'busy') {
      setBusyStartTime(data.start);
    }
    const rData: RecurringAppointment = {
      startTime: data.start,
      endTime: data.end,
      status: data.status === 'busy' ? 'busy' : 'available',
      isDeleted: false,
      slots: recurringData.slots,
      id: recurringData.id,
    };

    onChange(rData, itemIndex);
  };

  const isSlotsAvaiable = recurringData.slots && recurringData.slots.length > 0 ? true : false;

  return recurringData.isDeleted ? (
    <></>
  ) : (
    <div className="recurring-slots-row" key={itemIndex}>
      <div className={`recurring-slot petsked-form ${recurringData.status}`}>
        <div className="label-container">
          <label className="recurring-slot-label">
            {moment(recurringData.startTime).format('MMM DD, YYYY')}
          </label>
        </div>
        {recurringData.status != 'closed' && recurringData.status != 'holiday' ? (
          <>
            <DropDown
              data={
                isSlotsAvaiable && recurringData.slots
                  ? recurringData.slots
                  : [
                    {
                      label: recurringData.startTime,
                      value: recurringData.startTime,
                      isSelected: true,
                    },
                  ]
              }
              placeholder="Select Slot"
              selectedValue={recurringData.startTime}
              onSelect={onSlotSelect}
              onDismiss={() => { }}
              labelKey={isSlotsAvaiable ? 'start' : undefined}
              valueKey={isSlotsAvaiable ? 'start' : undefined}
              formatter={Utils.formatSlotDate}
              formatterData={user?.activeLocation?.timezone}
              isDisabled={
                recurringData.isUpcoming === false ? true : isSlotsAvaiable ? false : true
              }
              setObject={true}
            />
            {isLoading ? (
              <Loader text="" />
            ) : (
              <div className="icons">
                {recurringData.isUpcoming !== false && (
                  <DatePickerWithPortal
                    value={recurringData.startTime}
                    onChange={(val: DayValue) => {
                      setBusyStartTime('');
                      onEditDate(`${val?.month}/${val?.day}/${val?.year}`);
                    }}
                    placeholder={t('Select date of birth')}
                    showInput={false}
                    minimumDate={day}
                  />
                )}
                {!disableDelete && <span>
                  <DeleteIcon
                    className="delete-icon"
                    onClick={() => onDeleteClicked(recurringData, itemIndex)}
                  />
                </span>}
                {recurringData.startTime === busyStartTime && (
                  <span>
                    <OverlayTrigger
                      placement="auto"
                      delay={{ show: 250, hide: 400 }}
                      overlay={renderTooltip}
                    >
                      <WarningIcon className="warning-icon" />
                    </OverlayTrigger>
                  </span>
                )}
              </div>
            )}
          </>
        ) : (
          <>
            <span className="closed-label">Closed</span>
            {isLoading ? (
              <Loader text="" />
            ) : (
              <div className="icons">
                <DatePickerWithPortal
                  value={recurringData.startTime}
                  onChange={(val: DayValue) => {
                    setBusyStartTime('');
                    onEditDate(`${val?.month}/${val?.day}/${val?.year}`);
                  }}
                  placeholder={t('Select date of birth')}
                  showInput={false}
                  minimumDate={day}
                />
                {!disableDelete && <span>
                  <DeleteIcon
                    className="delete-icon"
                    onClick={() => onDeleteClicked(recurringData, itemIndex)}
                  />
                </span>}
                {recurringData.startTime === busyStartTime && (
                  <span>
                    <OverlayTrigger
                      placement="auto"
                      delay={{ show: 250, hide: 400 }}
                      overlay={renderTooltip}
                    >
                      <WarningIcon className="warning-icon" />
                    </OverlayTrigger>
                  </span>
                )}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};
